import React, { useState } from "react";
import { Tooltip } from "./Tooltip";
import { Link } from "react-scroll";

const Header = ({ classicHeader, darkTheme, homeRef, handleNavClick, toggleDarkMode }) => {
  const [isNavModalClose, setIsNavModalClose] = useState(true);
  return (
    <header id="header" className="sticky-top">
      {/* Navbar */}
      <nav className="primary-menu navbar navbar-expand-lg navbar-dark bg-dark border-bottom-0">
        <div className="container-fluid position-relative h-100 flex-lg-column ps-3 px-lg-3 pt-lg-3 pb-lg-2">
          {/* Logo */}
          <Link
            smooth
            duration={500}
            style={{ cursor: "pointer" }}
            to="home"
            className="mb-lg-auto mt-lg-4" 
            onClick={(e) => {
              e.preventDefault();
              setIsNavModalClose(true);
            }}
          >
            <span className="bg-dark-2 rounded-pill p-2 mb-lg-1 d-none d-lg-inline-block">
              <img
                className="img-fluid rounded-pill d-block"
                src="/images/fachu-dev-profile-grad.jpg"
                title="I'm Fachu"
                alt="profile"
                loading="eager"
                decoding="sync"
                style={{ 
                  aspectRatio: '1/1', 
                  objectFit: 'cover', 
                  objectPosition: 'center top',
                  imageRendering: 'auto',
                  filter: 'none',
                  maxWidth: '100%',
                  height: 'auto'
                }}
              />
            </span>
            {/* Logo para desktop */}
            <div className="d-none d-lg-block text-center">
              <img
                src="/fachudev-logo-low-800.png"
                alt="FACHU.DEV"
                style={{ height: '30px', width: 'auto' }}
                className="img-fluid"
              />
            </div>
            {/* Logo SVG para mobile */}
            <div className="d-block d-lg-none text-center">
              <img
                src="/fachudev-logo-low-800.png"
                alt="FACHU.DEV"
                style={{ height: '30px', width: 'auto' }}
                className="img-fluid"
              />
            </div>
          </Link>
          {/* Logo End */}
          <div
            id="header-nav"
            className={
              isNavModalClose
                ? "collapse navbar-collapse w-100 my-lg-auto "
                : "show navbar-collapse w-100 my-lg-auto"
            }
          >
            <ul className="navbar-nav text-lg-center my-lg-auto py-lg-3">
              <li className="nav-item">
                <Link
                  target={homeRef}
                  className="nav-link "
                  smooth
                  duration={500}
                  style={{ cursor: "pointer" }}
                  activeClass="active"
                  spy
                  to="home"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsNavModalClose(true);
                  }}
                >
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link "
                  smooth
                  duration={500}
                  style={{ cursor: "pointer" }}
                  activeClass="active"
                  spy
                  to="sectors"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsNavModalClose(true);
                  }}
                >
                  Sectors
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link "
                  smooth
                  duration={500}
                  style={{ cursor: "pointer" }}
                  activeClass="active"
                  spy
                  to="services"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsNavModalClose(true);
                  }}
                >
                  Services
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link "
                  smooth
                  duration={500}
                  style={{ cursor: "pointer" }}
                  activeClass="active"
                  spy
                  to="portfolio"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsNavModalClose(true);
                  }}
                >
                  Portfolio
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link "
                  smooth
                  duration={500}
                  style={{ cursor: "pointer" }}
                  activeClass="active"
                  spy
                  to="about"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsNavModalClose(true);
                  }}
                >
                  About
                </Link>
              </li>
              {/* Testimonials link temporarily hidden */}
              {/* <li className="nav-item">
                <Link
                  className="nav-link "
                  smooth
                  duration={500}
                  style={{ cursor: "pointer" }}
                  activeClass="active"
                  spy
                  to="testimonial"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsNavModalClose(true);
                  }}
                >
                  Testimonials
                </Link>
              </li> */}
              <li className="nav-item">
                <Link
                  className="nav-link "
                  smooth
                  duration={500}
                  style={{ cursor: "pointer" }}
                  activeClass="active"
                  spy
                  to="contact"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsNavModalClose(true);
                  }}
                >
                  Contact
                </Link>
              </li>
              
              {/* Dark Mode Toggle - Desktop (in navbar) */}
              <li 
                className="nav-item d-none d-lg-block d-lg-flex justify-content-center align-items-center" 
                style={{ 
                  display: 'flex !important'
                }}
              >
                <button
                  onClick={toggleDarkMode}
                  className="nav-link btn btn-link text-muted border-0 bg-transparent"
                  aria-label="Toggle dark mode"
                  title={darkTheme ? "Switch to light mode" : "Switch to dark mode"}
                  style={{ 
                    cursor: "pointer", 
                    minHeight: "inherit",
                    padding: '8px 12px'
                  }}
                >
                  <i className={`fa${darkTheme ? 's fa-sun' : 'r fa-moon'}`} style={{ fontSize: '16px' }}></i>
                </button>
              </li>
            </ul>
          </div>
          <ul className="social-icons social-icons-muted social-icons-sm mt-lg-auto ms-auto ms-lg-0 d-flex">
            <li className="social-icons-github d-none d-lg-block">
              <Tooltip text="Github" placement="top">
                <a
                  href="https://github.com/fachu-dev"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-github" />
                </a>
              </Tooltip>
            </li>
            <li className="social-icons-linkedin d-none d-lg-block">
              <Tooltip text="LinkedIn" placement="top">
                <a
                  href="https://www.linkedin.com/in/facundo-criscuolo"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-linkedin" />
                </a>
              </Tooltip>
            </li>
            <li className="social-icons-whatsapp">
              <Tooltip text="WhatsApp" placement="top">
                <a
                  href="https://wa.me/393890341230"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fab fa-whatsapp" />
                </a>
              </Tooltip>
            </li>
            <li className="social-icons-email">
              <Tooltip text="Email" placement="top">
                <a
                  href="mailto:criscuolo.facu@gmail.com"
                >
                  <i className="fas fa-envelope" />
                </a>
              </Tooltip>
            </li>
          </ul>
          
          {/* Dark Mode Toggle - Mobile (in header) */}
          <button
            onClick={toggleDarkMode}
            className="btn btn-link text-muted p-2 ms-2 border-0 bg-transparent d-lg-none"
            aria-label="Toggle dark mode"
            title={darkTheme ? "Switch to light mode" : "Switch to dark mode"}
          >
            <i className={`fa${darkTheme ? 's fa-sun' : 'r fa-moon'}`} style={{ fontSize: '18px' }}></i>
          </button>
          
          <button
            onClick={(e) => {
              setIsNavModalClose(!isNavModalClose);
            }}
            className={
              isNavModalClose ? "navbar-toggler" : "navbar-toggler show"
            }
            id="navbar-toggler"
            type="button"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </nav>
      {/* Navbar End */}
    </header>
  );
};

export default Header;
